function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
});

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 9,
  x2: 12,
  y2: 13
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 17,
  x2: 12.01,
  y2: 17
});

const SvgAlertTriangle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "feather feather-alert-triangle",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertTriangle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert-triangle.fc8aba7f.svg";
export { ForwardRef as ReactComponent };